import { Component, Renderer2 } from '@angular/core';
import { GameHostComponent } from '../game-host/game-host.component';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from '../shared/model/message';
import { MessageType } from '../shared/model/message-type';
import { GameStatus } from '../shared/model/game-status';
import { SpinnerService } from '../shared/services/spinner.service';
import { User } from '../shared/model/user';
import { DiceSubmission } from '../shared/model/liars-dice-game';
import { WindowsService } from '../shared/services/windows.service';

@Component({
  selector: 'pbg-page-liars-dice-host',
  templateUrl: './page-liars-dice-host.component.html',
  styleUrls: ['./page-liars-dice-host.component.scss']
})
export class PageLiarsDiceHostComponent extends GameHostComponent {
  gamePrefix = 'L';
  gameHasStarted = false;
  currentSubmitter: User;
  currentSubmission: DiceSubmission;
  waitingPlayerSubmitterName: string;

  constructor(
    socketService: SocketService,
    cookieService: CookieService,
    router: Router,
    resolver: ActivatedRoute,
    renderer: Renderer2,
    spinnerService: SpinnerService,
    windowService: WindowsService
  ) {
    super(
      socketService,
      cookieService,
      router,
      resolver,
      renderer,
      spinnerService,
      windowService
    );
  }

  hostMessageHandler(message: Message) {
    if (message.action === MessageType.Host) {
      this.connectedUsers = (<any>Object).values(message.content.users);
      this.avatarWidth = `calc(${Math.floor(100 / this.connectedUsers.length)}% - 20px)`;
      if (message.content.status === GameStatus.Waiting) {
        this.gameId = message.content.id;
        this.cookieService.set('gameId', this.gameId, 1, '/');
      } else if (message.content.status === GameStatus.Complete) {
        this.gameIsOver = true;
        this.winner = Object.keys(message.content.dice)[0];
        console.log('Game is Complete!');
      } else if (message.content.status === GameStatus.InProgress) {
        this.setGameState(message);
      }
    }
  }

  responseHandler(message: Message) {
    console.log(message);
    if (
      message.action === MessageType.Prompt &&
      message.content.status === GameStatus.InProgress
    ) {
      this.setGameState(message);
    }
  }

  setGameState(message: Message) {
    console.log('Set the game state!');
    this.gameHasStarted = true;
    this.currentSubmitter = message.content.currentSubmission.user;
    this.currentSubmission = message.content.currentSubmission;
    this.waitingPlayerSubmitterName = message.content.submitter;
    this.connectedUsers = (<any>Object).values(message.content.users);
  }
}
